import { IconCurrencyCircleDollar, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { RuleContent, RuleDescription, RuleIcon, Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { messages } from '../messages'

type BenefitProps = {
  value: number
}

export function MaxPriceBenefit(props: BenefitProps) {
  const { value } = props
  const { $t } = useIntl()
  const { formatCurrency } = useNumbers()

  return (
    <>
      <RuleIcon>
        <IconCurrencyCircleDollar />
      </RuleIcon>
      <RuleDescription>
        {$t(messages.benefit.maxPrice, {
          b: (content) => <Text variant="body">{content}</Text>,
        })}
      </RuleDescription>
      <RuleContent>
        <Tag>{formatCurrency(value)}</Tag>
      </RuleContent>
    </>
  )
}
